import React from "react";
import "./blockColorCode.css"

const BlockColorCode = (props) => {
    const {dataName, project_color_code} = props

        if (!project_color_code) return null

        if (dataName === 'project_color_code') {
          return ( 
            <span className="code__wrap">
            {project_color_code.map ((v,i) => {
                if (v.max_color_code === 1) return <span className="circle color-1" key={i}>{v.dev_qty}</span>
                if (v.max_color_code === 2) return <span className="circle color-2" key={i}>{v.dev_qty}</span>
                if (v.max_color_code === 3) return <span className="circle color-3" key={i}>{v.dev_qty}</span>
            })}
            </span>
           );
        }

        if (dataName === 'desk_color_code') {
            return ( 
              <span className="code__wrap">
              {project_color_code.map ((v,i) => {
                  if (v.max_color_code === 1) return <span className="circle color-1" key={i}>{v.dev_qty}</span>
                  if (v.max_color_code === 2) return <span className="circle color-2" key={i}>{v.dev_qty}</span>
                  if (v.max_color_code === 3) return <span className="circle color-3" key={i}>{v.dev_qty}</span>
              })}
              </span>
             );
          }

        return null;

    
}

export default BlockColorCode